import React from 'react'
import { connect } from "react-redux";
import { SetDepositPayments_BQR } from '$Deposits/store/actions/DepositPost'
import { BQR_Submit } from '$Deposits/store/actions/DepositEvent'
import { GetParamsData } from '$Deposits/lib/LibCommonData'


class BQR extends React.Component {

    constructor(props) {
        super(props);
        this.state = {

        };
    }

    componentDidMount() {

    }
    componentWillUnmount() {

    }

    render() {
        const { LivechatClick } = GetParamsData()
        const {
            DepositNextStep,
            DepositSuccessPage,
            SetDepositPayments_BQR,
            TipsView,
            NameInput,
            MoneyInput,
            SubmitBtn,
            NextStep,
            SuccessPage,
            AvailableMethods,
            BankNone,
            MethodsDetails,
            UserBankSelect,
            BanksBankAccounts
        } = this.props
        return (
            <>
                {
                    //没有银行卡
                    BanksBankAccounts.length == 0 &&
                    <>
                        <BankNone LivechatClick={LivechatClick} methods={'BQR'} />
                    </>
                }
                {
                    BanksBankAccounts.length > 0 && !DepositNextStep &&  !DepositSuccessPage &&
                    <>
                        <TipsView msg={'QR ฝากเงินทศนิยมแบบใหม่ ! สแกนได้ทั้งแอปธนาคาร และทรูวอลเล็ท'} />
                        <AvailableMethods />
                        <NameInput />
                        <UserBankSelect />
                        <MoneyInput />
                        <SubmitBtn
                            submitBtn={BQR_Submit}
                            onPress={() => { SetDepositPayments_BQR() }}
                            submitBtnItem={'ถัดไป'}
                        />
                    </>
                }
                {
                    DepositNextStep &&
                    <NextStep />
                }
                {
                    DepositSuccessPage &&
                    <SuccessPage />
                }
            </>
        );
    }
}

const mapStateToProps = state => ({
    DepositNextStep: state.DepositNextStep,
    DepositSuccessPage: state.DepositSuccessPage,
    MethodsDetails: state.MethodsDetails,
    BanksBankAccounts: state.BanksBankAccounts,
});
const mapDispatchToProps = {
    SetDepositPayments_BQR: (data = {}) => SetDepositPayments_BQR(data),
};
export default connect(mapStateToProps, mapDispatchToProps)(BQR);


